// extracted by mini-css-extract-plugin
module.exports = {"unit":"AbbrUnit--unit--c6PVB"};